import React, { Component, Fragment } from 'react';
import './bcac.css';
import BillBoard from './billBoard';
class RegisterStudent extends Component {

    render() {
        const {students, packageList}=this.props;
        return ( 
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="border_thumb">
                                    <div className="row">
                                        <div className="col-md-12">                                        
                                            <div className="caption bcacBox ">
                                                <div className="leftBox">
                                                    <h5>Select Students to Register</h5>
                                                    <p style={{marginLeft:'15px'}}>
                                                    {
                                                        Object.keys(students||{}).map((sid,i)=>{
                                                            const fullName=`${students[sid].lastName}, ${students[sid].firstName}`;
                                                            return(
                                                                <div className="checkbox">
                                                                    <label>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            checked={students[sid].isSelected} 
                                                                            value="" 
                                                                            disabled={students[sid].isRegistered}
                                                                            onChange={(e)=>{
                                                                                this.props.onSelectStudent(sid,e.target.checked)
                                                                            }}
                                                                            />{fullName}
                                                                    </label>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    </p>
                                                </div>
                                                <div className="rightBox">
                                                    <BillBoard {...this.props} />
                                                </div>                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        this.props.jumpToStep(1)
                    }}>Next
                    </button>
                </div>
            </div>
            </Fragment>
         );
    }
}
 
export default RegisterStudent;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/RegisterStudent.jsx